import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFrontierAuth } from '../util/auth/useFrontierAuth.ts';
import applicationRoutes from '../constants/applicationRoutes.ts';
import { ApplicationRoles } from '../constants/applicationRoles.ts';

const Home: React.FC = () => {
  const auth = useFrontierAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!auth.hasLoaded) {
      return;
    }
    if (auth.isAuthenticated) {
      if (auth.isInRole([ApplicationRoles.reservations])) {
        nav(applicationRoutes.agent.inbox);
      } else if (auth.isInRole([ApplicationRoles.folio])) {
        nav(applicationRoutes.agent.activityFolioV2);
      }
    } else {
      nav(applicationRoutes.account.login);
    }
  }, [auth.isAuthenticated, auth.user, auth.hasLoaded, nav]);

  return (
    <div>
      <p>Welcome to the Frontier Lodging Solutions database system.</p>
    </div>
  );
};

export default Home;
